<script>
    
    import { toast } from 'bulma-toast'
    import { userStore, invoicesStore } from '../stores' 
        
    import InvoicesService from '../$services/facturama.services'
    import DateMethod from '../$methods/date.method'

    import Table from '../$components/table.svelte'

    let loading = false

    getInvoices()

    async function getInvoices() {
        loading = true
        const resp = await InvoicesService.getInvoices($userStore._id)
        loading = false
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        invoicesStore.set(resp.data)

    }

</script>

<div class="subtitle is-5">Facturas</div>

<Table items={ $invoicesStore.length } { loading }>
    <thead>
        <tr>
            <th>#</th>
            <th class="has-text-right">Monto</th>
            <th>RFC</th>
            <th>Estatus</th>
            <th>Fecha</th>
        </tr>
    </thead>
    <tbody>
        {#each $invoicesStore as invoice, index}
            <tr>
                <td>{ index + 1 }</td>
                <td class="has-text-right">{ invoice.amount }</td>
                <td>{ invoice.rfc }</td>
                <td>{ invoice.status }</td>
                <td>{ DateMethod.dateShort(invoice.created) }</td>
            </tr>
        {/each}
    </tbody>
</Table>